import { useEffect, useState } from "react";
import { useRecruitmentMethodContext } from "api/settings/recruitment-method/RecruitmentMethodProviders";
import { FormattedMessage } from "react-intl";
import { HandleModaleBO } from "components/bo/HandleModaleBO";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { TableManager } from "components/bo/admin-table/TableManager";
import { ACTIONS, ENTITIES } from "constants/constants";
import { navigateView, navigateEdit, navigateToParent } from "utils/boHelper";
import Button from "core/buttons/button/Button";

export default function AdminRecruitmentMethods({ action }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const {
    recruitmentMethodByIdGetter,
    recruitmentMethodCreate,
    recruitmentMethodDeleteById,
    recruitmentMethodList,
    recruitmentMethodListGetter,
    recruitmentMethodPerId,
    recruitmentMethodUpdateById,
  } = useRecruitmentMethodContext();

  const recruitmentMethodForm = [
    { col: "id", mandatory: true, isMissingValue: null },
    { col: "en", mandatory: true, isMissingValue: null },
    { col: "fr", mandatory: true, isMissingValue: null },
  ];

  const [deleteData, setDeleteData] = useState(null);

  useEffect(() => {
    recruitmentMethodListGetter();
  }, [recruitmentMethodListGetter]);

  useEffect(() => {
    if (id) {
      recruitmentMethodByIdGetter(id);
    }
  }, [id]);

  const handleDelete = async (recruId) =>
    setDeleteData(recruitmentMethodList.find((e) => e.id === recruId));

  const validateDelete = async (recruId) => {
    try {
      await recruitmentMethodDeleteById(recruId);
    } catch (error) {
      console.error(error);
    }
  };
  const handleCreate = (payload) => {
    try {
      recruitmentMethodCreate(payload);
      navigateToParent(navigate, location);
    } catch (e) {
      console.error(e);
    }
  };
  const handleEdit = (payload) => {
    try {
      recruitmentMethodUpdateById(payload.id, payload);
      navigateToParent(navigate, location);
    } catch (e) {
      console.error(e);
    }
  };
  // Todo gestion droits admin
  return (
    <div>
      {action === ACTIONS.LIST && (
        <div className="flex">
          <Button
            className="btn-hover-color"
            size="large"
            color="blue"
            onClick={() => navigateView("new", navigate, location)}
          >
            <FormattedMessage
              id={"admin_create_new"}
              defaultMessage={"Nouveau"}
            />
          </Button>
        </div>
      )}
      <br />
      <TableManager
        action={action}
        entity={ENTITIES.RECRUITMENT_METHOD}
        entityPerId={recruitmentMethodPerId}
        list={recruitmentMethodList}
        inputs={recruitmentMethodForm}
        navigateEdit={(propsId) => navigateEdit(propsId, navigate, location)}
        navigateView={(propsId) => navigateView(propsId, navigate, location)}
        handleCreate={handleCreate}
        handleDelete={handleDelete}
        handleEdit={handleEdit}
      />

      <div id="modalDelete">
        <HandleModaleBO
          setDeleteData={setDeleteData}
          validateDelete={validateDelete}
          deleteData={deleteData}
          entity={ENTITIES.RECRUITMENT_METHOD}
        />
      </div>
    </div>
  );
}
